
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentDeviceApplications"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceApplicationBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"application"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationBasicFields"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"laneSide"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneSideBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lane"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"store"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoreBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RetailerBasicFields"},"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hardware"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HardwareBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hourIssue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastWifiScan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceOperationFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1161}};
    doc.loc.source = {"body":"#import '../application/ApplicationBasicFieldsFragment.gql'\n#import '../application/DeviceApplicationBasicFieldsFragment.gql'\n#import '../device_issue/DeviceIssueBasicFieldsFragment.gql'\n#import '../device_operation/DeviceOperationFieldsFragment.gql'\n#import '../hardware/HardwareBasicFieldsFragment.gql'\n#import '../lane/LaneBasicFieldsFragment.gql'\n#import '../lane_side/LaneSideBasicFieldsFragment.gql'\n#import '../retailer/RetailerBasicFieldsFragment.gql'\n#import '../store/StoreBasicFieldsFragment.gql'\n#import './DeviceFieldsFragment.gql'\n\nquery DeviceDetails($id: Int!) {\n  deviceDetails(id: $id) {\n    ...DeviceFields\n\n    currentDeviceApplications {\n      ...DeviceApplicationBasicFields\n\n      application {\n        ...ApplicationBasicFields\n      }\n    }\n\n    laneSide {\n      ...LaneSideBasicFields\n\n      lane {\n        ...LaneBasicFields\n\n        store {\n          ...StoreBasicFields\n\n          retailer {\n            ...RetailerBasicFields\n          }\n        }\n      }\n    }\n\n    hardware {\n      ...HardwareBasicFields\n    }\n\n    hourIssue {\n      ...DeviceIssueBasicFields\n    }\n\n    lastWifiScan {\n      ...DeviceOperationFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../application/ApplicationBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../application/DeviceApplicationBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../device_issue/DeviceIssueBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../device_operation/DeviceOperationFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../hardware/HardwareBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane/LaneBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane_side/LaneSideBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../retailer/RetailerBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../store/StoreBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceFieldsFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeviceDetails"] = oneQuery(doc, "DeviceDetails");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/device/DeviceDetailsQuery.gql
// module id = hquF
// module chunks = 87